import React from 'react'
import Profile from '../components/profile'

function Profiles() {
  return (
    <div>
      <Profile/>
    </div>
  )
}

export default Profiles
